
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import _export from '../internals/export.js';
import getBuiltIn$1 from '../internals/get-built-in.js';
import hasOwnProperty_1 from '../internals/has-own-property.js';
import toString$1 from '../internals/to-string.js';
import shared$1 from '../internals/shared.js';
import symbolRegistryDetection from '../internals/symbol-registry-detection.js';

var $ = _export;
var getBuiltIn = getBuiltIn$1;
var hasOwn = hasOwnProperty_1;
var toString = toString$1;
var shared = shared$1;
var NATIVE_SYMBOL_REGISTRY = symbolRegistryDetection;

var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  'for': function (key) {
    var string = toString(key);
    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = getBuiltIn('Symbol')(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  }
});
//# sourceMappingURL=es.symbol.for.js.map
